export default {"src":"/_next/static/media/line-bg.375d1813.svg","height":164,"width":270,"blurWidth":0,"blurHeight":0};